module.exports = {
	"articleTitle1": "Best Sandwich: Zingerman's Delicatessen ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Zingerman's Delicatessen",
	"articleLink1": "https://www.michigandaily.com/section/arts/boaa-zingermans",
	"articleLink2": "https://www.michigandaily.com/section/arts/best-sandwich-zingermans",
	"articleSnippet1": "Apr 5, 2017 ... Reubens to veggie to monstrous concoctions of tuna you can't believe made it \nonto a plate, let alone a slab of bread — this is Zingerman's.",
	"articleSnippet2": "Apr 3, 2016 ... If you've ever had the Georgia Reuben from Zingerman's Delicatessen, the \nanswer is probably yes. The sandwich that launched a thousand ...",
	"foodRecommendations": [
		{
			"text": "Has to be one of the best restaurants in AA. It's pretty pricey, so get your parents to take you here when they visit :P",
			"person": "Erik Forkin"
		},
		{
			"text": "They have really good gluten free bread for sandwiches!",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Best Sandwich: Zingerman's ",
	"address": "422 Detroit St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170407/eaa.BOAA_.Zingermans.3.31.16.002.jpg?itok=I6yEXPvE",
			"author": "Evan Aaron",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/ara.NEW_.Zingermans.4.7.15.0039.jpg",
			"author": "Amanda Allen",
			"caption": "Ari Weinzweig, Zingerman co-owner and founding partner, speaks about the creation of Zingerman's deli at an event hosted by Alpha Kappa Psi fraternity at the Michigan Union Ballroom on Tuesday."
		}
	],
	"position": {
		"lat": 42.284602,
		"lng": -83.745074
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/zingermans.json
// module id = 1004
// module chunks = 0